<script setup lang="ts">
import { computed, ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { signOutPortal } from '@/services/auth'
import { hasPermission } from '@/config/permissions'
const menuOpen = ref(false); const { user, role } = useAuth(); const router = useRouter()
const name = computed(() => user.value?.displayName || user.value?.email || 'Account')
async function signOut() { await signOutPortal(); await router.push('/login') }
</script>
<template>
  <header class="app-header"><RouterLink class="brand" to="/"><img src="https://amchurch.com/wp-content/uploads/2026/06/Alpharetta-Methodist-logomark-only-gold-scaled.png" alt="Alpharetta Methodist Church"/><span>AV <b>PORTAL</b></span></RouterLink>
    <button class="menu-toggle" aria-label="Toggle navigation" @click="menuOpen = !menuOpen">Menu</button>
    <nav :class="{ open: menuOpen }" aria-label="Primary navigation"><RouterLink to="/">Dashboard</RouterLink><RouterLink to="/plans">Plans</RouterLink><RouterLink to="/tickets">Tickets</RouterLink><RouterLink to="/docs">Documentation</RouterLink><RouterLink to="/tools">Tools</RouterLink><RouterLink v-if="hasPermission(role, 'users:manage')" to="/admin/users">Admin</RouterLink></nav>
    <div class="account"><RouterLink class="account-profile" to="/profile"><b>{{ name }}</b><small>{{ role }}</small></RouterLink><button class="quiet-button" @click="signOut">Sign out</button></div>
  </header>
</template>
